import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit {
  @Input() form: FormGroup;
  @Input() controlName: string;
  @Input() label: string;
  @Input() min: number;
  @Input() disabled: boolean = false;
  @Input() readonly: boolean = false;
  @Input() class :string = 'flex-auto  ml-2 mr-2 '

  constructor() { }

  ngOnInit(): void {
  }

}
